// extracted by mini-css-extract-plugin
module.exports = {"col":"_1ZzjPEcSmSqztIo0eSo3NC"};